

const React = require("react");

exports.classNames = {
};

const getDefault = (module) => module.default || module;

const addClass = (className, properties) => ({
  ...properties,
  className: properties.className ? properties.className + " " + className : className,
});

const castStyle = (value) => {
  const tov = typeof value;
  if (tov === "object" || tov !== "string") return value;
  return value.trim().split(";").reduce((obj, keyValue) => {
    const [key, value] = keyValue.split(":");
    if (!value || value === "undefined") return obj;
    const trimmedValue = value.trim();
    if (trimmedValue === "undefined") return obj;
    obj[key.trim()] = value && value.trim();
    return obj;
  }, {});
};

const getClassName = (className) => {
  return className ? className.split(" ").map(part => (
    "_e8981de3_" + part + " " +"_pub-e8981de3_" + part + " " +part
  )).join(" ") : "";
};

